<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >
        <header
            id="modalTitle"
            class="modal-header"
        >
          <slot name="header">
            Rappel : Fin des tests
          </slot>
        </header>

        <section
            id="modalDescription"
            class="modal-body"
        >
          <slot name="body">
            <div id="modalBody"/>
          </slot>
        </section>

        <footer class="modal-footer">
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="close"
          >
            Fermer
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    message: String
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    document.getElementById('modalBody').innerHTML = this.message
  }
};
</script>